import React from "react";
import InputBaseWithErrorLabel from "./InputBaseWithErrorLabel";
import { useValidate } from "formvalidation/hooks";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { CommonInputProps } from "./models";


const LastNameInput = (props: CommonInputProps) => {
  const { validatorKey, ...rest } = props;
  const semanticInputRef = useSemanticUiInputRef();

  const validateLastName = async () => {
    if (props.value.trim().length === 0) {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }
    return true;
  }

  const validation = useValidate({
    key: validatorKey,
    title: RESX.Contact.LastName,
    value: props.value,
    validate: validateLastName,
    ref: semanticInputRef.ref
  });

  return <InputBaseWithErrorLabel
    {...rest}
    innerRef={semanticInputRef.refSetter}
    error={validation.error.errorMessage ?? validation.error.hasError}
    maxLength={serverReference.constants.personName.maxLastNameLength}
    placeholder={RESX.Contact.LastName}
    fluid
  />
};

export default LastNameInput;